/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in popup Order006
 * @created at      :   2026/02/16
 * @created by      :   DaoNX
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';
import { MSG_NO_DATA } from '@/utils/constants';

const dataInit = {
    company_cd: '',
    company_name: '',
    department_cd: '',
    department_name: '',
    customer_name: '',
    status: '',
    keyword: '',
    working_date_start: '',
    working_date_end: ''
};

export default {
    namespaced: true,
    state: {
        data: { ...dataInit },
        searchData: [],
        options: {
            status: [],
            pageSize: [
                { code: 0, name: '全件表示' },
                { code: 100, name: '100件' },
                { code: 50, name: '50件' }
            ]
        },
        paginationData: {
            pageNo: 1,
            pageSize: 50,
            totalRows: 0,
            msgNoData: MSG_NO_DATA
        }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.paginationData.pageNo = 1;
            state.paginationData.pageSize = 50;
            state.paginationData.totalRows = 0;
            state.paginationData.msgNoData = MSG_NO_DATA;
            state.searchData = [];
        },
        setSearchData(state, data) {
            state.searchData = data ?? [];
        },
        setPageNavigation(state, data) {
            state.paginationData.pageNo = parseInt(data.page);
            state.paginationData.pageSize = parseInt(data.pageSize);
            state.paginationData.totalRows = parseInt(data.totalRows);
            state.paginationData.msgNoData = parseInt(data.totalRows) === 0 ? MSG_NO_DATA : '';
        },
        setCombobox(state, data) {
            state.options.status = data ?? [];
        }
    },
    actions: {
        actionSearch(context, request) {
            try {
                repository.search(request.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('setSearchData', data.Data.data);
                        context.commit('setPageNavigation', data.Data.paging);
                        if (request.callback) {
                            request.callback(data);
                        }
                    } else if (request.onError) {
                        request.onError(data.Data?.message ?? data.Message);
                    }
                });
            } catch (e) {
                console.log('Search: ' + e.message);
            }
        }
    }
};
